import { UnauthorizedPage } from '~/components/auth/UnauthorizedPage'
import { useActiveOrgMember } from '~/hooks/org'

export const SettingsPageContainer = ({
  children,
  requireOwner = false,
}: {
  children: React.ReactNode
  requireOwner?: boolean
}) => {
  const orgMember = useActiveOrgMember()

  if (requireOwner && orgMember?.role !== 'OWNER') {
    return (
      <UnauthorizedPage customMessage="This page is restricted to owners of this workspace. Please verify the selected workspace and that you are an owner." />
    )
  }

  return <>{children}</>
}

type SettingsPage =
  | 'general'
  | 'members'
  | 'networks'
  | 'recovery'
  | 'tokens'
  | 'banks'
  | 'api-keys'
  | 'gas'

// who can see each subpage in team settings
export const settingsVisibility: Record<SettingsPage, 'members' | 'owners'> = {
  general: 'members',
  members: 'members',
  networks: 'owners',
  recovery: 'owners',
  tokens: 'owners',
  banks: 'owners',
  'api-keys': 'members',
  gas: 'members',
}
